<template>
  <BaseDialog
    :title="$t('survey.editTitleAndMessage')"
    :is-open="isOpen"
    type="responsive"
    :align-dismiss-button-right="true"
    @close="closeDialog"
  >
    <BaseInputField
      v-model="formData.title"
      type="text"
      :label="$t('common.title')"
      class="bg-surface-container-high"
    />
    <DialogBreak />
    <WysiwygTextField v-model="formData.message" :placeholder="$t('survey.messagePlaceholder')" />

    <template #confirm>
      <BaseTextButton color="filled" :disabled="isSaving || !isFormValid" @click="saveSurveyEdits">
        {{ $t('common.save') }}
      </BaseTextButton>
    </template>
    <template #dismiss>
      <BaseTextButton color="text" :disabled="isSaving" @click="closeDialog">
        {{ $t('common.cancel') }}
      </BaseTextButton>
    </template>
  </BaseDialog>
</template>
<script setup lang="ts">
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import { useEditCoachSurvey } from '../composables/use-edit-coach-survey'
  import type { CoachSurvey } from '../composables/use-coach-survey'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import { computed, watch } from 'vue'
  import BaseInputField from '@/core/components/base/form-fields/BaseInputField.vue'
  import DialogBreak from '@/core/components/base/dialog/DialogBreak.vue'
  import WysiwygTextField from '@/core/components/base/wysiwyg/WysiwygTextField.vue'

  interface Props {
    isOpen: boolean
    survey: CoachSurvey
  }

  const props = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'close-dialog'): void
    (e: 'survey-updated'): void
  }>()

  const closeDialog = () => {
    emit('close-dialog')
    resetForm()
  }

  watch(
    () => props.isOpen,
    () => {
      resetForm()
    },
  )

  const { isFormValid, saveSurveyEdits, resetForm, formData, isSaving } = useEditCoachSurvey(
    computed(() => props.survey),
    () => {
      emit('survey-updated')
      closeDialog()
    },
  )
</script>
